<template>
  <el-row v-if="loaded">
    <el-popover placement="top-start" width="400" trigger="click">
      <el-row v-if="selectedDrafts&&buisnessTools">
        <el-button type="text" @click="goInvoice()">Τιμολόγησε τα επιλεγμένα ({{ getTotal()}})</el-button>
      </el-row>
      <el-row v-if="buisnessTools">
        <el-button type="text" @click="makeBalanses()">Αυτόματη κατανομή πληρωμών πάνω σε χρεώσεις</el-button>
      </el-row>

      <el-row v-if="buisnessTools">
        <el-button
          type="text"
          @click="mergeBusinesss()"
        >Συγχώνευση αυτου του πελάτη με αυτόν που θα επιλέξης</el-button>
      </el-row>
      <el-button slot="reference" type="text">
        <i class="material-icons">build</i>
      </el-button>
      <el-row>
        <el-button type="text" @click="setMode('tags');dialogVisible=true">Μετονομασία κατηγοριών</el-button>
      </el-row>
      <el-row>
        <el-button type="text" @click="setMode('place');dialogVisible=true">Μετονομασία έδρας</el-button>
      </el-row>
    </el-popover>
    <el-dialog
      title="Μετονομασίες"
      :visible.sync="dialogVisible"
      width="50%"
      destroy-on-close
      append-to-body
    >
      <el-row style="height:130px;">
        <s-tag-select
          v-if="dialogVisible"
          style="width:100%"
          :allowAdd="false"
          :key="renameMode"
          filterable
          @change="towhat=what"
          placeholder="Για τί πρόκειται..."
          v-model="what"
          :end-point="renameMode=='tags'?qTags:qPlaces"
          :value-prop="renameMode"
          :label-prop="renameMode"
        ></s-tag-select>
      </el-row>
      <el-input clearable v-model="towhat"></el-input>
      <el-row></el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="dialogVisible = false;rename()">Confirm</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import * as api from "~/api/resource";
import { mapMutations } from "vuex";
export default {
  name: "r-tools",
  props: {
    selectedDrafts: { type: Array, default: null },
    buisnessTools: { default: false, type: Boolean },
  },
  data() {
    return {
      renameMode: "tags",
      towhat: null,
      what: null,
      dialogVisible: false,
      loaded: false,
      // content: { searchdaterange: null, active: true, search: null }
    };
  },
  computed: {},
  watch: {
    // content: {
    //   handler: function(val, oldVal) {
    //     _log_("ela re...", val);
    //     this.$emit("input", val);
    //     this.$emit("change", val);
    //   },
    //   deep: true
    // }
  },
  created() {
    if (this.value) this.content = this.value;
    const date = new Date();
    this.loaded = true;
    // this.content = [date.getTime(), date.getTime()];
  },
  mounted() {
    // this.$emit("input", this.content);
  },
  methods: {
    setMode(mode) {
      this.what = null;

      this.towhat = null;
      this.renameMode = mode;
    },
    async rename() {
      var q = {
        what: this.what,
        towhat: this.towhat,
        replacefield: this.renameMode,
        do: "rename",
        table: "Transdrafts",
      };

      await api.updateProcessor("gears/tools", q);
      this.$emit("done", "renamed");
    },
    getTotal() {
      var s = 0;
      this.selectedDrafts.forEach((element) => {
        s += isNaN(element.cost) ? 0 : element.cost;
      });
      return this.$theMoney(s);
    },
    async goInvoice() {
      var draftIds = [];
      this.selectedDrafts.forEach((element) => {
        draftIds.push(element.id);
      });
      const { data } = await api.fetchProcessor("transdrafts/issueinvoice", {
        id: draftIds.join(","),
      });
      _log_("ooo,ΤΤΤΤc,", data);
      if (data && data.object && data.object.timologioId) {
        this.routeGo({
          name: "timologio",
          params: { id: data.object.timologioId },
        });
      } else this.$message.error("ΩΧ!!! κατι δεν πηγε καλά");
    },
    ...mapMutations({
      setStore: "helpers/setStore",
    }),
    mergeBusinesss() {
      this.setStore({
        storename: "mergeFromBusinessId",
        data: this.value.businessId,
      });
    },
    async makeBalanses() {
      const msg = this.$message({
        showClose: true,
        message: "μισό λεπτάκι το τακτοποιώ",
        type: "warning",
        duration: 0,
      });
      // pipeActions(['wBusiness=>business/update>=wBusiness','->reloadTrans','=>business/getlist>=businessList'],{limit:0,fixBalances:true,isbusiness:1,mode:'full'})"
      const data = await api.updateProcessor("business/update", {
        limit: 0,
        for: this.$route.params.direction,
        fixBalances: true,
        // isbusiness: 1,
        mode: "full",
        ...this.value,
      });
      _log_("fixed...", data, this.value);
      this.$emit("done", "fix-balanses");
      msg.close();
    },
  },
};
</script>
<style>
.el-switch__label .el-icon-circle-check,
.el-switch__label .el-icon-circle-close {
  font-size: 20px;
}
.el-popover {
  max-width: 100vw;
}
</style>
